// 翻訳保留中　
// このファイル内の日本語はデータと合わせる必要がありそうなため
// 日本語検索の正規表現↓
// ([0-9a-zA-Z -/:-@[-`{-~\s\t^])([^0-9a-zA-Z -/:-@[-`{-~\s\t])+([0-9a-zA-Z -/:-@[-`{-~\s\t\\n$])

if (!customElements.get('product-swiper')) {
  customElements.define('product-swiper', class ProductSwiper extends HTMLElement {
    constructor () {
      super();

      this.elSwiper = document.querySelector('.js-product-swiper');
      this.elThumbs = document.querySelectorAll('.js-product-thumb');

      if (this.elSwiper && this.elThumbs.length) {
        this.initProductSwiper();
      }
    }

    initProductSwiper () {
      this.productSwiper = new Swiper(this.elSwiper, {
        spaceBetween: 0,
        on: {
          afterInit: (swiper) => {
            this.elThumbs[swiper.realIndex].classList.add('thumb-media-active');
            for (let i = 0; i < this.elThumbs.length; i++) {
              this.elThumbs[i].onclick = () => {
                swiper.slideTo(i);
              };
            }
          },
          slideChange: (swiper) => {
            this.switchThumb(swiper.realIndex);
          },
        }
      });
    }

    switchThumb (index) {
      Array.from(this.elThumbs).forEach((elThumb) => {
        elThumb.classList.remove('thumb-media-active');
      });
      this.elThumbs[index].classList.add('thumb-media-active');
    }

    setActiveMedia (mediaId) {
      const index = Array.from(this.elThumbs).findIndex((elThumb) => elThumb.dataset.mediaId === mediaId);
      this.productSwiper.slideTo(index);
      this.switchThumb(index);
    }
  })
}

// 商品ページでの Zepto Product Personalizer の初期化イベント
window.addEventListener('pplrAppInitiated' , (e) => {
  const elProductType = document.querySelector('.js-product-type');
  const productType = elProductType.dataset.productType;

  const initPreview = () => {
    const elProductMainImage = document.querySelector('.js-product-main-image');
    const elPersonalizerPreview = document.querySelector('.js-personalizer-preview');
  
    // Personalizerがあるページのみ、Previewを表示する
    elPersonalizerPreview.classList.add('is-visible');
  
    // Personalizerがあるページでは、Main imageのstickyを外して、previewの方をstickyにする
    if (elProductMainImage && elPersonalizerPreview){
      elProductMainImage.classList.remove('is-sticky');
      elPersonalizerPreview.classList.add('is-sticky');
    }
  }

  const switchLabelDisplay = (property, targetSections, targetValues) => {
    let pplrLabels = document.querySelectorAll(".pplrlabel");
    for(let i = 0; i < pplrLabels.length; i++){
      const pplrLabel = pplrLabels[i];
      let isTarget = false
      targetSections.forEach((targetSection) => {
        if (pplrLabel.innerText.indexOf(targetSection) > -1) {
          isTarget = true;
        }
      });
      if (!isTarget) continue;

      targetValues.forEach((targetValue) => {
        pplrLabel.parentNode.querySelectorAll(".pplr-swatch-main span").forEach((span) => {
          if(span.dataset.name === targetValue){
            span.style.display = property;
          }
        });
      });
    }
  }


  const batZaisitsuBfjCustomize = (elPersonalizer) => {
    const elBfjMarkInput = elPersonalizer.querySelector('[name="properties[BFJマーク]"]');
    const elBfjMarkSwitch = elPersonalizer.querySelectorAll('[data-value="BFJマークなし"],[data-value="BFJマークあり"]' );
    const elZaishitsuSwitch = document.querySelectorAll('[data-ordermade-property-field="材質"]');
    const elZaishitsuInput = document.querySelector('[data-ordermade-cart-property][name="properties[材質]"]');
    if (!elBfjMarkInput || !elBfjMarkSwitch.length || !elZaishitsuSwitch.length || !elZaishitsuInput) return;

    // 材質がバーチ or メープルでBFJマークがありの場合、黒は非表示にする
    const targetSections = ['バットカラー', 'グリップ部分', 'ヘッド部分（30cm）'];
    const targetValues = ['ブラック'];
    const isZaishitsuTarget = elZaishitsuInput.value ==='北米産メイプル' || elZaishitsuInput.value === 'バーチ';
    const isBfjSelected = elBfjMarkInput.value === "BFJマークあり";
    if (isZaishitsuTarget && isBfjSelected) {
      switchLabelDisplay('none', targetSections, targetValues);
    }

    // Switch切り替え時のイベント追加
    Array.from(elZaishitsuSwitch).forEach((elSwitch) => {
      elSwitch.addEventListener('click', () => {
        if (elSwitch.value === '北米産メイプル' || elSwitch.value === 'バーチ') {
          if (elBfjMarkInput.value === "BFJマークあり") {
            switchLabelDisplay('none', targetSections, targetValues);
          }
        } else {
          switchLabelDisplay('block', targetSections, targetValues);
        }
      })
    });

    Array.from(elBfjMarkSwitch).forEach((elSwitch) => {
      elSwitch.addEventListener('click', () => {
        if (elBfjMarkInput.value === "BFJマークあり") {
          if (elZaishitsuInput.value === '北米産メイプル' || elZaishitsuInput.value === 'バーチ') {
            switchLabelDisplay('none', targetSections, targetValues);
          }
        } else {
          switchLabelDisplay('block', targetSections, targetValues);
        }
      })
    });
  }

  const batMarkColorCustomize = (elPersonalizer) => {
    const elBatColor1Input = elPersonalizer.querySelector('[name="properties[バットカラー（１色）]"]');
    const elBatColor30Input = elPersonalizer.querySelector('[name="properties[ヘッド部分（30cm）]"]');
    const elBatColor45Input = elPersonalizer.querySelector('[name="properties[ヘッド部分（45cm）]"]');
  
    const pplrLabels = document.querySelectorAll(".pplrlabel");
    for(let i = 0; i < pplrLabels.length; i++){
      const pplrLabel = pplrLabels[i];

      // 本体カラー区分の切り替え時に、選択されているカラーに応じて、マーク３カラーの表示を切り替え
      if (pplrLabel.innerText.indexOf('本体カラー区分') > -1) {
        pplrLabel.parentNode.querySelectorAll(".pplr-drop-item").forEach((elItem) => {
          elItem.addEventListener('click', () => {
            let selectedColor;
            const colorSecValue = pplrLabel.parentNode.querySelector('[name="properties[本体カラー区分]"]').value;
            if (colorSecValue === '１色') {
              selectedColor = elBatColor1Input? elBatColor1Input.value : null;
            } else if (colorSecValue === '30cm') {
              selectedColor = elBatColor30Input? elBatColor30Input.value : null;
            } else {
              selectedColor = elBatColor45Input? elBatColor45Input.value : null;
            }

            if (selectedColor) {
              switchLabelDisplay('block', ['マーク１カラー', 'マーク２カラー', 'マーク３カラー'], ['ゴールド', 'シルバー', 'ホワイト', 'ブラック']);
              if (selectedColor === 'ナチュラル') {
                switchLabelDisplay('none', ['マーク１カラー', 'マーク２カラー', 'マーク３カラー'], ['ゴールド', 'シルバー', 'ホワイト']);
              } else if (selectedColor === 'ブラック') {
                switchLabelDisplay('none', ['マーク１カラー', 'マーク２カラー', 'マーク３カラー'], ['ブラック']);
              }
            }
          });
        });
      }

      // ヘッド部分のカラーに応じて、マーク３カラーの表示を切り替え
      const targetSections = ['バットカラー（１色）', 'ヘッド部分（30cm）', 'ヘッド部分（45cm）'];
      let isTarget = false
      targetSections.forEach((targetSection) => {
        if (pplrLabel.innerText.indexOf(targetSection) > -1) {
          isTarget = true;
        }
      });
      if (!isTarget) continue;

      const parentNode = pplrLabel.parentNode;
      let elColorInput = parentNode.querySelector('.pplrjscolor');
      if (elColorInput.value === 'ナチュラル') {
        switchLabelDisplay('none', ['マーク１カラー', 'マーク２カラー', 'マーク３カラー'], ['ゴールド', 'シルバー', 'ホワイト']);
      }
      parentNode.querySelectorAll(".pplr-swatch-main span").forEach((elSpan) => {
        elSpan.addEventListener('click', () => {
          elColorInput = parentNode.querySelector('.pplrjscolor');

          switchLabelDisplay('block', ['マーク１カラー', 'マーク２カラー', 'マーク３カラー'], ['ゴールド', 'シルバー', 'ホワイト', 'ブラック']);
          if (elColorInput.value === 'ナチュラル') {
            switchLabelDisplay('none', ['マーク１カラー', 'マーク２カラー', 'マーク３カラー'], ['ゴールド', 'シルバー', 'ホワイト']);
          } else if (elColorInput.value === 'ブラック')  {
            switchLabelDisplay('none', ['マーク１カラー', 'マーク２カラー', 'マーク３カラー'], ['ブラック']);
          }
        });
      });
    }
  }

  const addHideClassToSentakuNashi = (elPersonalizer) => {
    let pplrLabels = elPersonalizer.querySelectorAll(".pplrlabel");
    for(let i = 0; i < pplrLabels.length; i++){
      const pplrLabel = pplrLabels[i];
      let isTarget = false
      if (pplrLabel.innerText.indexOf('選択なし') > -1) {
        isTarget = true;
      }
      if (!isTarget) continue;

      pplrLabel.parentNode.classList.add('is-hide');
    }
  }

  const addChargeOptionEvent = (elPersonalizer) => {
    const pplrLabels = elPersonalizer.querySelectorAll(".pplrlabel");
    const productOrdermade = document.querySelector("product-ordermade");
    if (!productOrdermade) return;

    // personalizerChargeOptions は personalizer-charge-option.liquid でglobalに定義
    personalizerChargeOptions.forEach((option) => {
      for(let i = 0; i < pplrLabels.length; i++){
        const pplrLabel = pplrLabels[i];

        if (pplrLabel.innerText === option.name) {
          const targetSection = pplrLabel.parentNode;
          const elInput = targetSection.querySelector(`input[name="properties[${option.name}]"]`);
          targetSection.querySelectorAll(".pplr-swatch-element").forEach((elItem) => {
            elItem.addEventListener('click', () => {
              const optionData = {
                variantId: option.variantId,
                price: option.price
              };
              if (elInput.value === option.value) {
                productOrdermade.addExternalChargeOption(optionData);
              } else {
                productOrdermade.deleteExternalChargeOption(optionData);
              }
            });
          });
        }
      }
    });
  }

  initPreview();

  const elPersonalizer = document.querySelector('.product-personalizer');
  if (!elPersonalizer) return;
  addHideClassToSentakuNashi(elPersonalizer);
  addChargeOptionEvent(elPersonalizer);

  if (productType === 'バット' || productType === 'オーダーバット' || productType === 'オーダーノックバット') {
    batZaisitsuBfjCustomize(elPersonalizer);
    batMarkColorCustomize(elPersonalizer);
  }

});

